import { Flex, SectionTitle, Box, Text, FormNumberInput } from '@shared/components';

export default function QuestionBlueprintSectionFormField() {
  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
      <SectionTitle title='QConfig Overview' />
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <Box sx={{ width: '240px' }}>
          <Text variant='body1Semibold'>จำนวนข้อสอบ</Text>
        </Box>
        <FormNumberInput
          label='จำนวนข้อสอบทั้งหมด'
          name='questionBlueprint.total'
          placeholder='ระบุจำนวนข้อสอบ'
          required
          helperText='ระบุได้สูงสุด 200 ข้อ'
          sx={{ width: '200px' }}
        />
      </Flex>
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <Box sx={{ width: '240px' }}>
          <Text variant='body1Semibold'>ประเภทคำถาม</Text>
        </Box>
        <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
          <FormNumberInput
            label='Single'
            name='questionBlueprint.single'
            placeholder='ระบุจำนวนข้อ'
            required
            sx={{ width: '200px' }}
          />
          <FormNumberInput
            label='ItemSet'
            name='questionBlueprint.itemSet'
            placeholder='ระบุจำนวนข้อ'
            required
            sx={{ width: '200px' }}
          />
        </Flex>
      </Flex>
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <Box sx={{ width: '240px' }}>
          <Text variant='body1Semibold'>ประเภทข้อสอบ</Text>
        </Box>
        <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
          <FormNumberInput
            label='คำนวณ'
            name='questionBlueprint.calculated'
            placeholder='ระบุจำนวนข้อ'
            required
            sx={{ width: '200px' }}
          />
          <FormNumberInput
            label='ไม่คำนวณ'
            name='questionBlueprint.nonCalculated'
            placeholder='ระบุจำนวนข้อ'
            required
            sx={{ width: '200px' }}
          />
        </Flex>
      </Flex>
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <Box sx={{ width: '240px' }}>
          <Text variant='body1Semibold'>ระดับความยาก</Text>
        </Box>
        <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
          <FormNumberInput
            label='ง่าย'
            name='questionBlueprint.easy'
            placeholder='ระบุจำนวนข้อ'
            required
            sx={{ width: '200px' }}
          />
          <FormNumberInput
            label='กลาง'
            name='questionBlueprint.medium'
            placeholder='ระบุจำนวนข้อ'
            required
            sx={{ width: '200px' }}
          />
          <FormNumberInput
            label='ยาก'
            name='questionBlueprint.hard'
            placeholder='ระบุจำนวนข้อ'
            required
            sx={{ width: '200px' }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
